import {
  Calendar,
  Clipboard,
  FileText,
  HeartPulse,
  Home,
  User,
  Users,
} from "lucide-react";
import type { RoleConfigs } from "../types/roles";

// Fonction utilitaire pour générer les sous-menus avec des paths uniques
const generateAccountSubMenu = (prefix: string) => [
  { path: `/${prefix}/dashboard/account/admin`, label: "Admin" },
  { path: `/${prefix}/dashboard/account/doctor`, label: "Docteur" },
  { path: `/${prefix}/dashboard/account/patient`, label: "Patient" },
  { path: `/${prefix}/dashboard/account/admin`, label: "Secrétaire" },
];

// Configuration commune pour admin et secrétaire
const sharedAdminConfig = {
  title: "Tableau de Bord Admin MIMAP",
  menuItems: [
    { path: "/admin/dashboard/accueil", icon: Home, label: "Accueil" },
    { path: "/admin/dashboard/patients", icon: Users, label: "Patients" },
    { path: "/admin/dashboard/patient", icon: User, label: "Enregistrements" },
    { path: "/admin/dashboard/constante", icon: HeartPulse, label: "Signes Vitaux" },
    { path: "/admin/dashboard/record", icon: Clipboard, label: "Medical Record" },
  ],
};

// Déclaration typée des rôles
export const roleConfigs = {
  patient: {
    title: "Tableau de Bord Patient",
    userLabel: "Patient",
    userEmail: "patient@mimap.com",
    loginRoute: "/login",
    menuItems: [
      { path: "/dashboard", icon: Home, label: "Accueil" },
      { path: "/dashboard/appointment", icon: Calendar, label: "Rendez-vous" },
      { path: "/dashboard/history", icon: FileText, label: "Historique Médical" },
      { path: "/dashboard/prescriptions", icon: Clipboard, label: "Ordonnances" },
      { path: "/dashboard/account", icon: User, label: "Mon Compte" },
    ],
  },
  doctor: {
    title: "Tableau de Bord Docteur",
    userLabel: "Docteur",
    userEmail: "doctor@mimap.com",
    loginRoute: "/doctor/login",
    menuItems: [
      { path: "/doctor/dashboard", icon: Home, label: "Accueil" },
      { path: "/doctor/dashboard/constante", icon: Users, label: "Demande Consultations" },
      { path: "/doctor/dashboard/record", icon: HeartPulse, label: "Medical Record" },
    ],
  },
  admin: {
    ...sharedAdminConfig,
    userLabel: "Admin",
    userEmail: "admin@mimap.com",
    loginRoute: "/admin/login",
    accountSubMenu: generateAccountSubMenu("admin"),
  },
  secretary: {
    ...sharedAdminConfig,
    userLabel: "Secrétaire",
    userEmail: "secretary@mimap.com",
    loginRoute: "/admin/login", // Partage la même route de login pour l'instant
    accountSubMenu: generateAccountSubMenu("secretary"),
  },
} satisfies RoleConfigs;
